module.exports = __webpack_public_path__ + "img/percentage-blue.05e74939.svg";